import * as Sentry from '@sentry/react'
import posthog from 'posthog-js'
interface Reporter {
  capture(exception: Error): void
  init(): void
  setUserId(id: string | undefined, isAnonymous: boolean | undefined): void
}

class PosthogSentryPosthogReporter implements Reporter {
  init() {
    const dsn = `https://b98738e77ec045bc6d8623619de274c4@o${process.env.NEXT_PUBLIC_SENTRY_ORG}.ingest.us.sentry.io/${process.env.NEXT_PUBLIC_SENTRY_PROJECT}`
    Sentry.init({
      environment: process.env.NODE_ENV,
      dsn,
      tunnel: `/api/sentry/tunnel`,
      ignoreErrors: [
        // https://github.com/getsentry/sentry-javascript/issues/3040, https://regex101.com/r/edUr9k/1
        /undefined is not an object \(evaluating 'window\.webkit\.messageHandlers.*'\)/,
      ],
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllInputs: false,
          maskAllText: false,
        }),
      ],
      // increase value length to capture more of sentry issue title
      maxValueLength: 1000,
      // Tracing
      tracesSampleRate: process.env.NODE_ENV === 'development' ? 1.0 : 0.1,
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [
        'localhost',
        /^https:\/\/sprites-codegen\.vercel\.app/,
        /^https:\/\/sprites\.ai/,
      ],
      // Session Replay
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    })
  }

  setUserId(id: string | undefined, isAnonymous: boolean | undefined) {
    if (id) {
      Sentry.setUser({ id, is_anonymous: isAnonymous })
      posthog.identify(id, { is_anonymous: isAnonymous })
    } else {
      Sentry.setUser(null)
      posthog.reset()
    }
  }

  capture(exception: Error) {
    Sentry.captureException(exception)
    posthog.captureException(exception)
  }
}

export const reporter: Reporter = new PosthogSentryPosthogReporter()
